import { computed, onMounted, ref, watch } from "vue";
import { nextTick } from "vue";
import { useStore } from "@/store";
import type { RoamingCountryStruct } from "@/struct/RoaminStruct";
import type { Ref } from "vue";

export function useRoamingView(roamingInfoTitle: Ref<HTMLElement | null>) {
  const store = useStore();

  const selectedCountry = ref<RoamingCountryStruct | null>(null);
  const isSticky = ref<boolean>(false);

  const selectedZone = computed(() => store.state.roaming.selectedZone);
  const othersCountriesList = computed(
    () => store.state.roaming.othersCountriesList
  );
  const othersCountriesCount = computed(
    () => store.state.roaming.othersCountriesCount
  );
  const popularCountries = computed(() => store.state.roaming.popularCountries);

  const getPopular = () => {
    store.dispatch("roaming/fetchPopularCountries");
  };

  const selectCountry = (country: RoamingCountryStruct) => {
    selectedCountry.value = country;
  };

  const identicalCountriesWithActive = (itemUuid: string) => {
    return itemUuid === selectedCountry.value?.uuid;
  };

  watch(
    () => selectedCountry.value,
    async (newSelectedCountry) => {
      if (newSelectedCountry?.roaming_zone_uuid) {
        await store.dispatch(
          "roaming/fetchZone",
          newSelectedCountry.roaming_zone_uuid
        );
        nextTick(() => {
          if (roamingInfoTitle.value) {
            roamingInfoTitle.value.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        });
        store.dispatch(
          "roaming/fetchOthersCountries",
          newSelectedCountry.roaming_zone_uuid
        );
      } else {
        store.dispatch("roaming/resetZoneSelection");
      }
    }
  );

  onMounted(() => {
    getPopular();
  });

  return {
    identicalCountriesWithActive,
    isSticky,
    othersCountriesList,
    othersCountriesCount,
    popularCountries,
    selectedCountry,
    selectedZone,
    selectCountry,
  };
}
